import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-obsidian text-white" data-id="element-83" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "15px"
    }} data-id="element-84" data-mp="32nukolv2nz0b">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-aqua" data-id="element-85" data-mp="36oxyz3xh1mzf">Sigma Smart™</p>
        <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-86" data-mp="3ufa64ckw7foy">
          Il Sistema Triathlon Full Distance™
        </p>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-white/70" data-id="element-87" data-mp="387e5ix8d5do">
          Allenati con metodo. Gestisci meglio le energie. Affronta la gara con più sicurezza.
        </p>
        <p className="mt-2 text-sm text-white/50" data-id="element-88" data-mp="3qbvm7atu2f68">
          Un unico sistema per organizzare il percorso dalla preparazione al traguardo.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-89" data-mp="2ey0ayd61uqka">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-white" data-id="element-90" data-mp="3l9k292unj58j">
            <MailIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-91" data-mp="3gcjw6rxsy2hf" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="https://instagram.com/sigmasmartitaliano" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-white" data-id="element-92" data-mp="3q8n30b3lmpap">
            <InstagramIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-93" data-mp="34p8v6p2nshq" /> @sigmasmartitaliano
          </a>
        </div>

        <nav aria-label="Note legali" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/45" data-id="element-94" data-mp="hsadx65ic1sa">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-95" data-mp="cw34329zq652">Termini e condizioni</a>
          <span aria-hidden="true" data-id="element-96" data-mp="mrwmh2ae4tur">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-97" data-mp="mt7rf5fko7ng">Informativa sulla privacy</a>
          <span aria-hidden="true" data-id="element-98" data-mp="twxsxe84bibf">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-99" data-mp="ytxxtlt8ef0y">Assistenza</a>
        </nav>

        <p className="mt-8 text-xs text-white/35" data-id="element-100" data-mp="13t0y6sy9nx2l">© 2026 SIGMA SMART™ — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}